$(document).ready(function () {

    // window.addEventListener("load", function () {
    //     window.cookieconsent.initialise({
    //         "palette": {
    //             "popup": {
    //                 "background": "#1247c7",
    //                 "text": "#ffffff"
    //             },
    //             "button": {
    //                 "background": "#73c3f3"
    //             }
    //         },
    //         "content": {
    //             "message": "Nós utilizamos cookies para otimizar e aprimorar sua navegação do site, manter uma melhoria contínua no conteúdo oferecido e aperfeiçoar a experiência de nossos usuários. Todos os cookies, exceto os estritamente necessários, necessitam de seu consentimento para serem executados. Saiba mais nos nossos termos de privacidade",
    //             "dismiss": "Aceito os termos",
    //             "href": "<%= ENV['HOST'] %>",
    //             "link": 'Saiba mais'
    //         }
    //     })
    // });
    
});